/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const removeInvitationFromOrg = createFOAsyncThunk('removeInvitation/removeInvitationFromOrg', async (args) => {
  return userApi.removeInvitationFromOrganization(args.orgId, args.invitationId);
});
